import React from "react";
import {
	Container,
	Grid,
	Paper,
	Typography,
	List,
	ListItem,
	ListItemIcon,
	ListItemText,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import CollectionsIcon from "@mui/icons-material/Collections";
import PeopleIcon from "@mui/icons-material/People";

const useStyles = (theme) => ({
	container: {
		paddingTop: theme.spacing(4),
		paddingBottom: theme.spacing(4),
	},
	paper: {
		padding: theme.spacing(2),
		display: "flex",
		overflow: "auto",
		flexDirection: "column",
	},
	sectionTitle: {
		marginBottom: theme.spacing(1),
		fontWeight: "bold",
	},
});

// Registry of available features. Add new features here as { label, icon, viewKey }.
const FEATURES = [
	{
		label: "Card Collection",
		icon: <CollectionsIcon />,
		viewKey: "cardcollection-view",
	},
	{
		label: "Buddies (FB friends & requests)",
		icon: <PeopleIcon />,
		viewKey: "buddies-view",
	},
];

const FeaturesView = ({ classes, onSelectFeature }) => {
	return (
		<Container maxWidth="lg" className={classes.container}>
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<Paper className={classes.paper}>
						<Typography variant="h6" className={classes.sectionTitle}>
							Features
						</Typography>
						<List>
							{FEATURES.map((feature) => (
								<ListItem
									button
									key={feature.viewKey}
									onClick={() => onSelectFeature(feature.viewKey)}
								>
									<ListItemIcon>{feature.icon}</ListItemIcon>
									<ListItemText primary={feature.label} />
								</ListItem>
							))}
						</List>
					</Paper>
				</Grid>
			</Grid>
		</Container>
	);
};

export default withStyles(useStyles)(FeaturesView);
